import { Breadcrumb } from 'react-bootstrap';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { StepConfig } from '../botWizardConfigs';

interface RenderBreadcrumbsProps {
  steps: StepConfig[];
  stepIndex: number;
}

const renderBreadcrumbs = ({ steps, stepIndex }: RenderBreadcrumbsProps) => {
  if (!steps?.length) return null;

  return steps.slice(0, stepIndex + 1).map(step => (
    <Breadcrumb.Item key={step.key} active className="tw-whitespace-nowrap">
      {step.breadcrumbLabel ?? step.key}
    </Breadcrumb.Item>
  ));
};

export default WrappedErrorBoundary(renderBreadcrumbs);
